export enum TransferType {
  TED = 'ted',
  P2P = 'p2p',
  PIX = 'pix',
  PSP = 'psp',
}

export enum TransferLimitsFields {
  TED = 'ted',
  P2P = 'p2p',
}
